import {
  DashboardCardContent,
  DashboardCardHeader,
  DashboardCard,
} from '@pages/dashboard/components';
import { useGetDashboard } from '@pages/dashboard/hooks';
import { Typography, Button } from '@ui/components';
import { HasPermission } from '@shared/components';
import { Plus, Car } from '@ui/components/icons';
import { useHasPermission } from '@shared/hooks';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Routes } from '@shared/enums';
import { cn } from '@ui/utils';
import React from 'react';

export const DashboardVehicles = (props: React.ComponentPropsWithoutRef<'div'>) => {
  const { className, ...rest } = props;
  const { t } = useTranslation();
  const hasPermission = useHasPermission('DASHBOARD_VEHICLES_SEE_ALL', 'READ');
  const { data, isLoading } = useGetDashboard();

  return (
    <DashboardCard className={cn('justify-between', className)} {...rest}>
      <DashboardCardHeader
        link={{
          label: t('DASHBOARD.VEHICLES.SEE_ALL'),
          href: `../${Routes.VEHICLES}`,
        }}
        title={t('DASHBOARD.VEHICLES.TITLE')}
        isLinkVisible={hasPermission}
        icon={<Car />}
      />
      <DashboardCardContent className="justify-center" isLoading={isLoading} loaderSize="small">
        <div className="flex items-center justify-between">
          <Typography variant="h400">{data?.numberOfVehicles}</Typography>
          <HasPermission permissionFeature="DASHBOARD_VEHICLES_ADD_NEW" permissionType="WRITE">
            <Link state={{ openVehicleDrawer: true }} to={`../${Routes.VEHICLES}`}>
              <Button icon>
                <Plus />
              </Button>
            </Link>
          </HasPermission>
        </div>
      </DashboardCardContent>
    </DashboardCard>
  );
};
